const COLUMNS_GROUPS = [
  {
    id: "profilename",
    label: "Profile Name",
    widget: "text",
    width: 200
  },
  {
    id: "expenseaccount",
    label: "Expense Account",
    widget: "text",
    width: 200
  },
  {
    id: "vendorname",
    label: "Vendor Name",
    widget: "text",
    width: 180
  },
  {
    id: "frequency",
    label: "Frequency",
    widget: "text",
    width: 120
  },
  {
    id: "lastexpensedate",
    label: "Last Expense Date",
    widget: "date",
    width: 160
  },
  {
    id: "nextexpensedate",
    label: "Next Expense Date",
    widget: "date",
    width: 160
  },
  {
    id: "status",
    label: "Status",
    widget: "status",
    width: 120
  },
  {
    id: "amount",
    label: "Amount",
    widget: "number",
    width: 120
  }
];

const ROW_DATA = [
  {
    profilename: "Office Rent - Monthly",
    expenseaccount: "Office Rent",
    vendorname: "ABC Properties",
    frequency: "Monthly",
    lastexpensedate: "2025-01-01",
    nextexpensedate: "2025-02-01",
    status: "Active",
    amount: 25000
  },
  {
    profilename: "Internet Bill",
    expenseaccount: "Utilities",
    vendorname: "Airtel Broadband",
    frequency: "Monthly",
    lastexpensedate: "2025-01-15",
    nextexpensedate: "2025-02-15",
    status: "Active",
    amount: 1899
  },
  {
    profilename: "Office Cleaning",
    expenseaccount: "Maintenance",
    vendorname: "CleanPro Services",
    frequency: "Weekly",
    lastexpensedate: "2025-01-28",
    nextexpensedate: "2025-02-04",
    status: "Paused",
    amount: 3000
  }];

export {ROW_DATA, COLUMNS_GROUPS};